const users = [
    {
        name: "Mary",
        email: "mary@gmail.com",
        password: "123",
        shoppingCarts: [{ id: 12, count: 2 }],
        orders: [],
        status: false
    }
]

export default users